export const
GET_TEXTS_SUCCESS = "GET_TEXTS_SUCCESS",
GET_TEXTS_REQUEST = "GET_TEXTS_REQUEST",
GET_TEXTS_FAILURE = "GET_TEXTS_FAILURE";


// WEBPACK FOOTER //
// ./src/types/Texts.js